import React from 'react';
import PropTypes from 'prop-types';
import { X, Check } from '@wix/wix-ui-icons-common';
import IconButton from '../IconButton';
import { DataHooks } from './constants';
import { classes } from './ColorPickerActions.st.css.js';
const ColorPickerActions = ({ onCancel, onConfirm, disabled }) => (React.createElement("div", { className: classes.root },
    React.createElement(IconButton, { dataHook: DataHooks.cancelButton, size: "small", priority: "secondary", onClick: onCancel },
        React.createElement(X, null)),
    React.createElement(IconButton, { dataHook: DataHooks.confirmButton, size: "small", disabled: disabled, onClick: onConfirm },
        React.createElement(Check, null))));
ColorPickerActions.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
export default ColorPickerActions;
//# sourceMappingURL=ColorPickerActions.js.map